import { mapToList } from "./utils";

// 门店等级 T0-T9
export const EnumStoreGrade = {
  T0: "T0",
  T1: "T1",
  T2: "T2",
  T3: "T3",
  T4: "T4",
  T5: "T5",
  T6: "T6",
  T7: "T7",
  T8: "T8",
  T9: "T9",
};

export const StoreGradeToTextMap = new Map([
  [EnumStoreGrade.T0, "T0级"],
  [EnumStoreGrade.T1, "T1级"],
  [EnumStoreGrade.T2, "T2级"],
  [EnumStoreGrade.T3, "T3级"],
  [EnumStoreGrade.T4, "T4级"],
  [EnumStoreGrade.T5, "T5级"],
  [EnumStoreGrade.T6, "T6级"],
  [EnumStoreGrade.T7, "T7级"],
  [EnumStoreGrade.T8, "T8级"],
  [EnumStoreGrade.T9, "T9级"],
]);

export const StoreGradeList = mapToList(StoreGradeToTextMap);

export const AlipaySubMerchantStatus = {
  A: 0,
  B: 1,
  C: 2,
  D: 3,
};

export const AlipaySubMerchantStatusToTextMap = new Map([
  [AlipaySubMerchantStatus.A, "待进件"],
  [AlipaySubMerchantStatus.B, "进件中"],
  [AlipaySubMerchantStatus.C, "已生效"],
  [AlipaySubMerchantStatus.D, "审核拒绝"],
]);

export const AlipaySubMerchantStatusList = mapToList(AlipaySubMerchantStatusToTextMap);
